<template>
    <header class="header-pos">
      <v-layout align-center justify-center row>
          <v-flex justify-begin class="cont-titulo-curso" xs12 pl-2 >
                <!-- <p><span v-html="subtemaName">Portugues A1.1</span></p> -->
                <p v-if="!simple">Alfabeto</p>
          </v-flex>
          <div class="cont-libro">
              <p>Português A1.1</p>
          </div>
      </v-layout>
      <v-layout row wrap v-if="!simple">
          <v-flex xs12 class="cont-pantalla" text-xs-right>
            <span>Tela <strong>{{screenTrack[0]+1}}</strong> / <strong>{{screenTrack[1]}}</strong></span>
          </v-flex>
      </v-layout>
    </header>
</template>
<script>
    import resourcesLoader from "../js/mixins/resources-loader";
    export default { 
        mixins: [resourcesLoader],
        props:{
            simple:{
                type:Boolean,
                default:false
            }
        },
        data() {
            return {
                titulo: '',
                logo: '',
            }
        },
        methods: {
            getData(data) {
                return data
            }
        },
        created() {
            var self = this
            this.getJson('textos_proyecto', function (data) {
                self.titulo = data.nombre_del_proyecto
            })
            this.getPng('imagenes_compartidas/logo_ecopetrol', data => {
                self.logo = data
            })
        },
        methods: {
            getModuleTitle() {
                return this.$store.state.title
            }
        },
        computed: {
            screenTrack() {
                return this.$store.state.screens;
            },
            temaName() {
                return this.$store.state.tema;
            },
            subtemaName() {
                console.log('SUBTEMANAME '+this.$store.state.subTema)
                return this.$store.state.subTema;
            },
            showTrack() {
                var routeArr = this.$route.path.split("/");
                if (routeArr.length <= 2) {
                    return false
                } else {
                    return true
                }
            },
            currentPage() {
                return Math.floor(this.$route.params.unipage);
            }
        },
        watch: {
          screenTrack(val){
            let bar = this.$refs['progressBar']
            let pct = ((val[0]+1)/val[1]) * 100
            console.log('pct: '+pct)
            bar.style.width = pct+"%"
          }
        }

    }
</script>
<style lang="scss" scoped>
@import '../sass/globals';
.header-pos{
    position: fixed;
    width: 100%;
    z-index: 3;
}
header {
    background-color: rgba($color: white, $alpha: 1);
    padding: 0px;
    position: relative;
    z-index: 1;
    min-height: 50px;
    p {
        margin: 0;
        padding: 0;
    }
}
.cont-titulo-curso{
    p{
        font-size: 10px;
        font-family: Poppins-BoldItalic;
        color: #084476;
    }
}
.cont-libro{
    background: url("../assets/imagenes_compartidas/Fondo_Titulo.svg")no-repeat;
    min-height: 53px;
    width: 250px;
    display: flex;
    justify-content: end;
    margin-left: 0;
    background-size: cover;
    text-align: center;
    padding-top: 2px;
    p{
        text-align: center;
        margin: 0 auto;
        font-size: 13px;
        font-family: Poppins-BoldItalic;
    }
}
.cont-pantalla{
    font-family: Poppins-Regular;
    color: #666666;
    font-size: 10px;
    margin-top: -15px;
    padding-right: 30px;
    @media screen and (max-width: 900px) {
        padding-right: 50px;
    }
}


</style>

